import { Badge, Dropdown, Popconfirm } from "antd";
import { MoreOutlined } from "@ant-design/icons";
import { useMemo } from "react";
import { Link } from "react-router-dom";
import {
  GoBack,
  HeaderUser,
  IconDil,
  IconNojftimet,
  LogoFlex,
} from "../../../assets/icons";
import HamburgerMenu from "../../../utils/MobileComponents/HamburgerMenu";
import DynamicHeaderTitle from "../DynamicHeaderTitle";
import { useAuth } from "../../../authentication/authHelpers";
import { useSelector } from "react-redux";
import ThemeToggle from "./ThemeToggle";

function MobileHeader({
  location,
  handleLogOut,
  setRequestsActive,
  requestsActive,
  pendingRequest,
  setNotifsActive,
  setOpenStats,
  notifsActive,
  count,
  setOpenContactsModal,
  userPhoto,
  problemsActive,
  setProblemsActive,
  problematikatCount,
  setInterviewActive,
  interviewActive,
  candidatesCount,
  browserPushToggle = null,
}) {
  const auth = useAuth();
  const { isDarkMode } = useSelector((state) => state.usersList);

  const [isConfig, isKryefaqja] = useMemo(() => {
    return [
      location.pathname.startsWith("/konfigurimet"),
      location.pathname.startsWith("/kryefaqja"),
    ];
  }, [location.pathname]);

  const renderPfp = useMemo(
    () =>
      userPhoto?.length > 0 && userPhoto !== null ? (
        <img
          src={userPhoto}
          alt="Flex"
          width={32}
          height={32}
          style={{ borderRadius: 5 }}
        />
      ) : (
        <HeaderUser />
      ),
    [userPhoto]
  );

  const isAdmin =
    auth?.user?.userRole === "Admin" || auth?.user?.userRole === "Super Admin";

  const overflowItems = useMemo(() => {
    if (isConfig) return [];
    const items = [
      {
        key: "contacts",
        label: "Kontaktet",
        onClick: () => setOpenContactsModal(true),
      },
    ];
    if (isAdmin) {
      items.push(
        {
          key: "requests",
          label: (
            <span>
              Detyrat{" "}
              {pendingRequest?.length ? (
                <Badge count={pendingRequest.length} size="small" />
              ) : null}
            </span>
          ),
          onClick: () => setRequestsActive(!requestsActive),
        },
        {
          key: "org",
          label: "Grafiku organizativ",
          onClick: () => setOpenStats((prev) => !prev),
        },
        {
          key: "interviews",
          label: (
            <span>
              Intervistat{" "}
              {candidatesCount ? (
                <Badge count={candidatesCount} size="small" />
              ) : null}
            </span>
          ),
          onClick: () => setInterviewActive(!interviewActive),
        },
        {
          key: "problems",
          label: (
            <span>
              Support{" "}
              {problematikatCount ? (
                <Badge count={problematikatCount} size="small" />
              ) : null}
            </span>
          ),
          onClick: () => setProblemsActive(!problemsActive),
        },
      );
    }
    return items;
  }, [
    isConfig,
    isAdmin,
    pendingRequest?.length,
    candidatesCount,
    problematikatCount,
    requestsActive,
    interviewActive,
    problemsActive,
    setOpenContactsModal,
    setRequestsActive,
    setOpenStats,
    setInterviewActive,
    setProblemsActive,
  ]);

  return (
    <div
      className={`header-app mobile-header-bar ${isDarkMode ? "dark" : ""}`}
      style={{
        width: "100%",
        ...(isDarkMode ? {} : { background: isConfig ? "#b31312" : "#1d3445" }),
      }}
    >
      <HamburgerMenu data={auth} />
      {isConfig ? <DynamicHeaderTitle /> : null}

      <div className="icons mobile-header-icons">
        {isKryefaqja ? (
          <>
            <Link
              to="/konfigurimet/kompania/profili"
              aria-label="Profili"
            >
              {renderPfp}
            </Link>
            <ThemeToggle />
          </>
        ) : null}

        {isConfig ? (
          <Link
            to="/kryefaqja"
            style={{ margin: 0, padding: 0 }}
            aria-label="Kryefaqja"
          >
            <GoBack fill="#fff" />
          </Link>
        ) : null}

        {!isKryefaqja && !isConfig ? (
          <>
            <Link
              to="/konfigurimet/kompania/profili"
              aria-label="Profili"
            >
              {renderPfp}
            </Link>
            <ThemeToggle />
            <Link
              to="/kryefaqja"
              style={{ margin: 0, padding: 0 }}
              aria-label="Kryefaqja"
            >
              <GoBack fill="#fff" />
            </Link>
          </>
        ) : null}

        {!isConfig ? (
          <>
            {browserPushToggle}
            <button
              type="button"
              className="mobile-header-icon-btn"
              aria-label="Njoftimet"
              onClick={() => setNotifsActive(!notifsActive)}
            >
              <Badge className="notification-badge" count={count?.length}>
                <IconNojftimet />
              </Badge>
            </button>

            {overflowItems.length ? (
              <Dropdown
                menu={{ items: overflowItems }}
                trigger={["click"]}
                placement="bottomRight"
              >
                <button
                  type="button"
                  className="mobile-header-icon-btn mobile-header-more"
                  aria-label="Më shumë veprime"
                >
                  <MoreOutlined style={{ fontSize: 20, color: "#fbfbfb" }} />
                </button>
              </Dropdown>
            ) : null}
          </>
        ) : null}

        <Popconfirm
          placement="bottom"
          title={"A jeni të sigurt që dëshironi të dilni nga programi?"}
          onConfirm={handleLogOut}
          okText="Po"
          cancelText="Jo"
          classNames={{
            root: `popup-logout-modal globalPopover ${
              isDarkMode ? "dark" : ""
            }`,
          }}
          icon={<LogoFlex width={45} height={45} />}
        >
          <button
            type="button"
            className="mobile-header-icon-btn"
            aria-label="Dil"
          >
            <IconDil />
          </button>
        </Popconfirm>
      </div>
    </div>
  );
}

export default MobileHeader;
